import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { DriversService } from "../drivers-service/drivers-service";
import * as moment from 'moment-timezone';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { downloadBase64File } from "src/app/utils/pdf-downloader";
import { sweetAlert } from '../../../utils/swal';
import Swal from 'sweetalert2';
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { takeUntil } from "rxjs/operators";
import { CsvService } from "src/app/service/csv-service/csv.service";

@Component({
  selector: "app-driver-timelines",
  templateUrl: "./driver-timelines.component.html",
  styleUrls: ["./driver-timelines.component.css"],
})
export class DriverTimelinesComponent implements OnInit, OnDestroy {
  user;
  search;
  drivers;
  selectedDriver;
  timeline;
  timelines;
  timelineEvents = [];
  isDriverTimedIn = false;
  view = 'today';
  isShowBreakPopup = false;
  applyCaTimeSheet = false;
  currentDateTime = moment().startOf('day');
  preDateRange = [
    moment().startOf('day'),
    moment().endOf('day')
  ]
  dateRange = [
    moment().startOf('day').toISOString(),
    moment().endOf('day').toISOString()
  ];
  break;

  // dates = {
  //   startDate: moment().startOf('day'),
  //   endDate: moment().endOf('day')
  // };
  timeZone;

  isHistoryData: boolean = false;
  isTodayData: boolean = false;
  isSelectedDriver: boolean = false;

  isBreakSubmitted = false;
  isTimelineSubmitted = false;
  breakDetail: boolean = false;
  editShift: boolean = false;
  showEditSessionModal: boolean = false;
  editingSession: any = null;
  isSessionSubmitted: boolean = false;
  showAddBreakModal: boolean = false;
  newBreak: any = { start: null, stop: null };
  isBreakFormSubmitted: boolean = false;
  isSavingBreak: boolean = false;
  isSavingSession: boolean = false;
  showAddSessionModal: boolean = false;
  newSession: any = { checkin: null, checkout: null };
  isSessionFormSubmitted: boolean = false;
  isEditingBreak: boolean = false;
  selectedBreak = {
    time: moment().set({ 'hours': 0, 'minutes':5 }),
    min: moment().set({ 'hours': 0, 'minutes': 1 }),
    max: moment().set({ 'hours': 23, 'minutes': 59}),
  }

  @ViewChild('btnCloseTimelineModal', null) btnClose: ElementRef;
  constructor(
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private csvService: CsvService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.user = user;
          this.applyCaTimeSheet = this.user.applyCaTimeSheet;
          this.timeZone = this.user.timeZone;
          this.dateRange = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
          this.getDrivers();
        }
      });
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.drivers = data;
        }
      });
  }

  setView(view) {
    this.view = view;
    this.getDriverTimelines();
  }

  onSelectDriver(driver) {
    this.selectedDriver = driver;
    this.getDriverTimelines();
    this.closeView();
  }

  getDriverTimelines() {
    if (!this.selectedDriver) return;
    let queryString = {
      driver: this.selectedDriver._id
    };

    if (this.view === 'history') {
      queryString['dates'] = { "startDate": this.dateRange[0], "endDate": this.dateRange[1] };
    }

    this.driverService
      .getDriverTimelines(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.view === 'today') {
            this.timeline = data;
            this.buildTimelineEvents();
          } else if (this.view === 'history') {
            this.timelines = {};
            if (data.length) {
              this.timelines = data[0];
              if (this.timelines.jobs && this.timelines.jobs.length) {
                this.timelines.jobs.forEach(job => {
                  const breakStats = this.calculateBreaksTakenAndDue(job.breaks);
                  job.mealTaken = breakStats.mealTaken;
                  job.restTaken = breakStats.restTaken;
                  job.mealDue = breakStats.mealDue;
                  job.restDue = breakStats.restDue;
                });
              }
            }
          }
        } else {
          this.timeline = undefined;
          this.timelines = undefined;
          this.timelineEvents = [];
        }
      });
  }

  showBreakPopup() {
    this.isShowBreakPopup = !this.isShowBreakPopup;
    if (this.isShowBreakPopup) {
      this.isBreakSubmitted = false;
      this.break = undefined;
    }
  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  calculateBreaksTakenAndDue(breaks) {
    let mealTaken = 0;
    let restTaken = 0;
    let mealDue = 0;
    let restDue = 0;
    const now = moment().tz(this.timeZone);

    if (breaks && breaks.length) {
      breaks.forEach((b) => {
        if (b.start && b.stop) {
          const stopTime = moment(b.stop).tz(this.timeZone);
          const isRest = b.status === 'rest';
          const isMeal = b.status === 'approved';

          if (stopTime.isAfter(now)) {
            if (isRest) {
              restDue++;
            } else if (isMeal) {
              mealDue++;
            }
          } else {
            if (isRest) {
              restTaken++;
            } else if (isMeal) {
              mealTaken++;
            }
          }
        }
      });
    }

    return { mealTaken, restTaken, mealDue, restDue };
  }

  onChangeDate(evt) {
    this.dateRange = [evt[0].tz(this.timeZone).startOf('day').toISOString(), evt[1].tz(this.timeZone).endOf('day').toISOString()];
    this.getDriverTimelines();
  }

  selectDuration(value) {
    this.break = value;
  }

  // saveBreak() {
  //   this.isBreakSubmitted = true;
  //   if (!this.break) return;
  // }

  saveBreak() {
    let totalMinutes = 0;
    if(this.break === 'custom'){
      const hours =  moment(this.selectedBreak.time).hours();
      const minutes = moment(this.selectedBreak.time).minutes();
      totalMinutes = hours * 60 + minutes;
    }
    this.isBreakSubmitted = true;
    if (!this.break) return;
    if (this.break === 10 || this.break === 15 || this.break === 30 || this.break === 'custom') {
      this.action('approved', { value: this.break === 'custom' ? totalMinutes : this.break })
    } else {
      this.action('open');
    }
  }
  checkBreak() {
    if (this.timeline.status === 'approved') {
      let isBreak = false;
      let lastBreakTimeEnd;
      let stop = moment().tz(this.timeZone);
      let lastBreak = this.timeline.breaks[this.timeline.breaks.length - 1];
      if (lastBreak) {
        lastBreakTimeEnd = moment(lastBreak.stop).tz(this.timeZone);
        if (moment.duration(lastBreakTimeEnd.diff(stop)).asSeconds() > 1) {
          isBreak = true;
        }
      }
      if (isBreak) {
        sweetAlert('Alert', 'Driver is already on a break. Break ends at ' + lastBreakTimeEnd.format('HHmm'), 'warning', 'Ok')
      }
      return isBreak;
    }
  }
  action(status, data?) {
    let payload: any = {
      driver: this.selectedDriver._id,
      currDriver: {
        _id: this.selectedDriver._id,
        deviceKey: this.selectedDriver._id.deviceKey,
        deviceType: this.selectedDriver._id.deviceType
      },
      status: status,
      break: {
        status: status,
        label: 'Your break request is ' + status
      }
    };

    if (status === 'none') {
      payload['checkin'] = moment().tz(this.timeZone).toISOString();
      delete payload.break;
    }

    if (status === 'approved') {
      if (this.checkBreak()) {
        return;
      }
      let start = moment().tz(this.timeZone);
      let stop = moment().tz(this.timeZone).add(data.value, 'minutes');
      let duration = moment.duration(stop.diff(start));
      payload.break.duration = duration.asMilliseconds();
      payload.break.value = data.value;
      payload.break.start = start.toISOString();
      payload.break.stop = stop.toISOString();
    }

    if (status === 'open') {
      if (this.checkBreak()) {
        return;
      }
      payload.break.label = 'Back office has sent you on a break';
      payload.break.value = -1;
      payload.break.start = moment().tz(this.timeZone).toISOString();
    }

    if (status === 'close') {
      let start = moment(data.start).tz(this.timeZone);
      let stop = moment().tz(this.timeZone);
      let value = stop.diff(start, 'minutes')
      payload.status = 'approved';
      payload.break = {
        source: 'dispatcher',
        label: 'The back office has ended your break',
        status: 'approved',
        start: data.start,
        stop: stop.toISOString(),
        value: value,
        duration: moment.duration(stop.diff(start)).asMilliseconds()
      }
    }

    if (status === 'completed') {
      let start = moment(this.timeline.checkin).tz(this.timeZone);
      let stop = moment().tz(this.timeZone);
      let duration = moment.duration(stop.diff(start));
      let breakTimeInMillis = 0;
      let isBreak = false;
      let lastBreakTimeEnd;
      this.timeline.breaks.forEach((b) => {
        isBreak = false;
        if (b.status === 'approved') {
          lastBreakTimeEnd = moment(b.stop).tz(this.timeZone);
          if (moment.duration(lastBreakTimeEnd.diff(stop)).asSeconds() > 1) {
            isBreak = true;
          }
          breakTimeInMillis += b.duration;
        }
      });
      if (isBreak) {
        return sweetAlert('Alert', 'Driver is already on a break. Break ends at ' + lastBreakTimeEnd.format('HHmm'), 'warning', 'Ok')
      }
      payload.checkin = start;
      payload.breakTimeInMillis = breakTimeInMillis || 0;
      payload.workTimeInMillis = (duration.asMilliseconds() - breakTimeInMillis) || 0;
      payload.checkout = stop;
      delete payload.break;
    }
    this.sendRequest(payload);
  }

  sendRequest(payload) {
    // ----
    sweetAlert('Alert', 'Are you sure you want to proceed?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.driverService
            .saveDriverBreak(payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              if (data) {
                this.break = undefined;
                this.isShowBreakPopup = false;
                this.timeline = data;
                this.buildTimelineEvents();
              }
            });
        }
      })
    // ----
  }

  viewDetail(currentTimeline) {
    this.timeline = undefined;
    this.driverService
      .getDriverTimelineById(currentTimeline._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeline = data;
          this.buildTimelineEvents();
        }
      });
    this.breakHistory();
  }

  deleteDetail(currentTimeline) {
    sweetAlert('Alert', 'Are you sure you want to delete?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.driverService
            .deleteDriverTimelineById(currentTimeline._id)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              if (data) {
                this.getDriverTimelines();
              }
            });
        }
      })
  }

  deleteLastSession(timeline) {
    sweetAlert('Alert', 'Deleting this entry will delete the timesheet history entry. Do you want to proceed?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.driverService
            .deleteDriverTimelineById(timeline._id)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              if (data) {
                this.getDriverTimelines();
                this.closeView();
              }
            });
        }
      });
  }

  editDetail(currentTimeline) {
    this.timeline = undefined;
    this.isTimelineSubmitted = false;
    this.driverService
      .getDriverTimelineById(currentTimeline._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeline = data;
          this.buildTimelineEvents();
        }
      });
    this.shiftEdit();
  }

  saveTimeline() {
    this.isTimelineSubmitted = true;
    if (!this.timeline.checkin || !this.timeline.checkout) {
      return;
    }

    let start = moment(this.timeline.checkin).tz(this.timeZone);
    let stop = moment(this.timeline.checkout).tz(this.timeZone);

    const now = moment().tz(this.timeZone);
    if (start.isAfter(now)) {
      return sweetAlert('Alert', 'Time In cannot be after the current time', 'warning', 'Ok');
    }
    if (stop.isAfter(now)) {
      return sweetAlert('Alert', 'Time Out cannot be after the current time', 'warning', 'Ok');
    }

    if (!this.timeline._id && this.timelines && this.timelines.jobs) {
      const startDayStr = start.format('YYYY-MM-DD');
      const alreadyExists = this.timelines.jobs.some(job => {
        return moment(job.checkin).tz(this.timeZone).format('YYYY-MM-DD') === startDayStr;
      });
      if (alreadyExists) {
        return sweetAlert('Alert', 'Timesheet entry already exists for this day.', 'warning', 'Ok');
      }
    }

    let duration = moment.duration(stop.diff(start));
    let breakTimeInMillis = 0;
    let isBreak = false;
    let lastBreakTimeEnd;
    if (this.timeline && this.timeline.breaks) {
      this.timeline.breaks.forEach((b) => {
        isBreak = false;
        if (b.status === 'approved') {
          lastBreakTimeEnd = moment(b.stop).tz(this.timeZone);
          if (moment.duration(lastBreakTimeEnd.diff(stop)).asSeconds() > 1) {
            isBreak = true;
          }
          let lastBreakTimeStart = moment(b.start).tz(this.timeZone);
          let duration = moment.duration(lastBreakTimeEnd.diff(lastBreakTimeStart));
          b.duration = duration.asMilliseconds();
          breakTimeInMillis += b.duration;
        }
      });
    }
    if (isBreak) {
      return sweetAlert('Alert', 'Driver is already on a break. Break ends in ' + lastBreakTimeEnd.format('HHmm'), 'warning', 'Ok')
      // alert('Driver is already on a break. Break ends in ' + lastBreakTimeEnd.format('HHmm'));
    }
    this.timeline.breakTimeInMillis = breakTimeInMillis || 0;
    this.timeline.workTimeInMillis = (duration.asMilliseconds() - breakTimeInMillis) || 0;
    this.timeline.checkin = start;
    this.timeline.checkout = stop;
    // this.timeline.status = 'completed';
    if (this.timeline._id) {
      this.saveTimelineRequest(this.timeline);
    } else {
      this.timeline.driver = this.selectedDriver._id;
      this.saveTimelineRequest(this.timeline);
    }
    this.editShift = false;
  }

  saveTimelineRequest(payload) {
    this.driverService
      .saveDriverTimeline(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.timeline = data;
        if (this.timelines) {
          // this.btnClose.nativeElement.click();
          this.getDriverTimelines();
        }
      });
  }

  addTimeSheet() {
    this.shiftEdit();
    this.isTimelineSubmitted = false;
    this.timeline = {
      checkin: null,
      checkout: null
    };
  }

  generateReport(type?) {
    let queryString = {};
    queryString['dates'] = { "startDate": this.dateRange[0], "endDate": this.dateRange[1] };
    if (type === 'driver') {
      queryString['driver'] = this.selectedDriver._id;
    }
    this.driverService
      .getDriverTimelinesReport(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          const res = data[0];
          if (res.content && res.pdfName) {
            downloadBase64File(res.content, res.pdfName);
          }
        }
      });
  }

  generateCSVReport(){
    const date = { "startDate": this.dateRange[0], "endDate": this.dateRange[1] }
   this.csvService.multiSheet(this.timelines,date,this.selectedDriver)
  }

  breakHistory() {
    this.breakDetail = true
    this.editShift = false;
  }

  shiftEdit() {
    this.editShift = true;
    this.breakDetail = false;
  }

  deleteSession(session) {
    if (!this.timeline || !this.timeline.sessions) return;

    // Check if session contains any breaks
    if (this.timeline.breaks && this.timeline.breaks.length) {
      const hasBreak = this.timeline.breaks.some(b => {
        const breakTime = moment(b.start || b.updatedAt);
        const sessionCheckin = moment(session.checkin);
        const sessionCheckout = session.checkout ? moment(session.checkout) : null;
        return breakTime.isSameOrAfter(sessionCheckin) && (!sessionCheckout || breakTime.isBefore(sessionCheckout));
      });

      if (hasBreak) {
        return sweetAlert('Alert', 'This entry contains break(s) and cannot be deleted.', 'warning', 'Ok');
      }
    }

    sweetAlert('Alert', 'Are you sure you want to delete this time entry?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          // Remove the session from sessions array
          const index = this.timeline.sessions.findIndex(s => s._id === session._id);
          if (index > -1) {
            this.timeline.sessions.splice(index, 1);
          }

          this.buildTimelineEvents();
          const times = this.calculateWorkAndBreakTime();
          if (times.workTimeInMillis) {
            this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
          }
          this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

          // Update checkin/checkout from remaining sessions
          if (this.timeline.sessions.length) {
            this.timeline.checkin = this.timeline.sessions[0].checkin;
            const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
            this.timeline.checkout = lastSession.checkout || null;
          }

          this.saveTimelineRequest(this.timeline);
          this.buildTimelineEvents();
        }
      });
  }

  deleteBreak(breakItem) {
    if (!this.timeline || !this.timeline.breaks) return;

    sweetAlert('Alert', 'Are you sure you want to delete the break?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          const index = this.timeline.breaks.findIndex(b => {
            if (breakItem._id && b._id) {
              return b._id === breakItem._id;
            }
            return b.start === breakItem.start && b.stop === breakItem.stop;
          });

          if (index > -1) {
            this.timeline.breaks.splice(index, 1);
          }

          this.buildTimelineEvents();
          const times = this.calculateWorkAndBreakTime();
          if (times.workTimeInMillis) {
            this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
          }
          this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

          this.saveTimelineRequest(this.timeline);
          this.buildTimelineEvents();
        }
      });
  }

  checkBreakOverlap(startVal, stopVal, excludeBreakId?): boolean {
    if (!this.timeline || !this.timeline.breaks) return false;

    return this.timeline.breaks.some(b => {
      if (excludeBreakId && b._id === excludeBreakId) {
        return false;
      }
      if (b.status !== 'approved' && b.status !== 'open') return false;
      const bStart = moment(b.start).tz(this.timeZone);
      const bEnd = b.stop ? moment(b.stop).tz(this.timeZone) : null;
      if (bEnd) {
        return startVal.isBefore(bEnd) && bStart.isBefore(stopVal);
      }
      return bStart.isBefore(stopVal);
    });
  }

  openEditBreak(breakItem) {
    this.newBreak = JSON.parse(JSON.stringify(breakItem));
    this.isBreakFormSubmitted = false;
    this.isEditingBreak = true;
    this.showAddBreakModal = true;
  }

  updateBreak(startVal, stopVal) {
    debugger;
    if (!this.newBreak || !this.newBreak.start || !this.newBreak.stop) {
      return;
    }

    if (!this.timeline || !this.timeline.breaks) return;
    const index = this.timeline.breaks.findIndex(b => b._id === this.newBreak._id);
    if (index > -1) {
      const duration = moment.duration(stopVal.diff(startVal));
      const durationInMinutes = Math.round(duration.asMinutes());

      this.timeline.breaks[index].start = startVal.toISOString();
      this.timeline.breaks[index].stop = stopVal.toISOString();
      this.timeline.breaks[index].duration = duration.asMilliseconds();
      this.timeline.breaks[index].value = durationInMinutes;
    }

    this.buildTimelineEvents();
    const times = this.calculateWorkAndBreakTime();
    if (times.workTimeInMillis) {
      this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
    }
    this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

    this.isSavingBreak = true;
    this.driverService
      .saveDriverTimeline(this.timeline)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.isSavingBreak = false;
        if (data) {
          this.timeline = data;
          this.buildTimelineEvents();
          this.getDriverTimelines();
          this.closeAddBreak();
        }
      }, () => {
        this.isSavingBreak = false;
      });
  }

  openEditSession(session) {
    this.editingSession = JSON.parse(JSON.stringify(session));
    this.isSessionSubmitted = false;
    this.showEditSessionModal = true;
  }

  isDateDifferent(date1, date2): boolean {
    if (!date1 || !date2) return false;
    return !moment(date1).tz(this.timeZone).isSame(moment(date2).tz(this.timeZone), 'minute');
  }

  isAnyOverlayOpen(): boolean {
    return this.showEditSessionModal ||
           this.showAddBreakModal ||
           this.showAddSessionModal ||
           (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible());
  }

  closeEditSession() {
    if (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible()) return;
    setTimeout(() => {
      this.showEditSessionModal = false;
      this.editingSession = null;
    }, 0);
  }

  updateSession() {
    this.isSessionSubmitted = true;
    if (!this.editingSession || !this.editingSession.checkin) {
      return;
    }

    if (!this.timeline || !this.timeline.sessions) return;
    const index = this.timeline.sessions.findIndex(s => s._id === this.editingSession._id);
    if (index > -1) {
      let checkinVal = moment(this.editingSession.checkin).tz(this.timeZone);
      let checkoutVal = this.editingSession.checkout ? moment(this.editingSession.checkout).tz(this.timeZone) : null;

      if (checkoutVal && moment.duration(checkoutVal.diff(checkinVal)).asSeconds() < 0) {
        return sweetAlert('Alert', 'Time Out cannot be before Time In', 'warning', 'Ok');
      }

      const now = moment().tz(this.timeZone);
      if (checkinVal.isAfter(now)) {
        return sweetAlert('Alert', 'Time In cannot be after the current time', 'warning', 'Ok');
      }
      if (checkoutVal && checkoutVal.isAfter(now)) {
        return sweetAlert('Alert', 'Time Out cannot be after the current time', 'warning', 'Ok');
      }

      if (this.checkOverlap(checkinVal, checkoutVal, this.editingSession._id)) {
        return sweetAlert('Alert', 'This session overlaps with an existing session.', 'warning', 'Ok');
      }

      // Break boundary checks (applies to both open-ended and closed sessions)
      if (this.timeline.breaks && this.timeline.breaks.length) {
        const completedBreaks = this.timeline.breaks.filter(b => b.start && b.stop);

        if (completedBreaks.length) {
          // Sort breaks chronologically
          const sorted = [...completedBreaks].sort(
            (a, b) => moment(a.start).valueOf() - moment(b.start).valueOf()
          );

          // 1. Checkin must not go after the first break's start
          const firstBreak = sorted[0];
          const firstBreakStart = moment(firstBreak.start).tz(this.timeZone);
          if (checkinVal.isAfter(firstBreakStart)) {
            const formatted = firstBreakStart.format('HHmm');
            return sweetAlert('Alert', `Time In cannot be after the break start (${formatted}).`, 'warning', 'Ok');
          }

          // 2. Checkout (if exists) must not go before the last break's stop
          if (checkoutVal) {
            const lastBreak = sorted[sorted.length - 1];
            const lastBreakStop = moment(lastBreak.stop).tz(this.timeZone);
            if (checkoutVal.isBefore(lastBreakStop)) {
              const formatted = lastBreakStop.format('HHmm');
              return sweetAlert('Alert', `Time Out cannot be before the break end (${formatted}).`, 'warning', 'Ok');
            }
          }

          // 3. Open-ended session: checkin must not fall inside any break window
          if (!checkoutVal) {
            const overlappingBreak = sorted.find(b => {
              const bStart = moment(b.start).tz(this.timeZone);
              const bStop = moment(b.stop).tz(this.timeZone);
              return checkinVal.isSameOrAfter(bStart) && checkinVal.isBefore(bStop);
            });
            if (overlappingBreak) {
              const bStart = moment(overlappingBreak.start).tz(this.timeZone).format('HHmm');
              const bStop = moment(overlappingBreak.stop).tz(this.timeZone).format('HHmm');
              return sweetAlert('Alert', `Time In overlaps with an existing break (${bStart} – ${bStop}).`, 'warning', 'Ok');
            }
          }
        }
      }

      this.timeline.sessions[index].checkin = checkinVal;
      this.timeline.sessions[index].checkout = checkoutVal;

      this.buildTimelineEvents();
      const times = this.calculateWorkAndBreakTime();
      if (times.workTimeInMillis) {
        this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
      }
      this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

      if (this.timeline.sessions.length) {
        this.timeline.checkin = this.timeline.sessions[0].checkin;
        const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
        this.timeline.checkout = lastSession.checkout || null;
      }

      this.saveTimelineRequest(this.timeline);
      this.buildTimelineEvents();
      this.closeEditSession();
    }
  }

  openAddBreak() {
    this.newBreak = {
      start: null,
      stop: null
    };
    this.isBreakFormSubmitted = false;
    this.showAddBreakModal = true;
  }

  closeAddBreak() {
    if (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible()) return;
    setTimeout(() => {
      this.showAddBreakModal = false;
      this.newBreak = { start: null, stop: null };
      this.isEditingBreak = false;
    }, 0);
  }

  saveNewBreak() {
    debugger;
    this.isBreakFormSubmitted = true;
    if (!this.newBreak.start || !this.newBreak.stop) {
      return;
    }

    let startVal = moment(this.newBreak.start).tz(this.timeZone);
    let stopVal = moment(this.newBreak.stop).tz(this.timeZone);

    if (!this.isEditingBreak && this.timeline && this.timeline.checkin) {
      let baseDate = moment(this.timeline.checkin).tz(this.timeZone);
      startVal = baseDate.clone().hours(startVal.hours()).minutes(startVal.minutes()).seconds(0).milliseconds(0);
      stopVal = baseDate.clone().hours(stopVal.hours()).minutes(stopVal.minutes()).seconds(0).milliseconds(0);
    }

    if (moment.duration(stopVal.diff(startVal)).asSeconds() <= 0) {
      return sweetAlert('Alert', 'Stop Time cannot be before or equal to Start Time', 'warning', 'Ok');
    }

    const isWithinAnySession = this.timeline && this.timeline.sessions && this.timeline.sessions.some(s => {
      const sessionStart = moment(s.checkin).tz(this.timeZone);
      const sessionEnd = s.checkout ? moment(s.checkout).tz(this.timeZone) : null;
      return startVal.isSameOrAfter(sessionStart) && (!sessionEnd || stopVal.isSameOrBefore(sessionEnd));
    });

    if (!isWithinAnySession) {
      return sweetAlert('Alert', 'Break must fall within an existing time entries.', 'warning', 'Ok');
    }

    if (this.checkBreakOverlap(startVal, stopVal, this.isEditingBreak ? this.newBreak._id : undefined)) {
      return sweetAlert('Alert', 'Break overlaps with an existing break.', 'warning', 'Ok');
    }

    if (this.isEditingBreak) {
      this.updateBreak(startVal, stopVal);
    } else {
      this.saveBreakFromTimeline(startVal, stopVal);
    }
  }

  saveBreakFromTimeline(startVal, stopVal) {
    const duration = moment.duration(stopVal.diff(startVal));
    const durationInMinutes = Math.round(duration.asMinutes());

    let payload: any = {
      driver: this.selectedDriver._id,
      currDriver: {
        _id: this.selectedDriver._id,
        deviceKey: this.selectedDriver._id.deviceKey,
        deviceType: this.selectedDriver._id.deviceType
      },
      status: 'approved',
      break: {
        status: 'approved',
        label: 'Your break request is approved',
        value: durationInMinutes,
        start: startVal.toISOString(),
        stop: stopVal.toISOString(),
        duration: duration.asMilliseconds()
      },
      checkin: this.timeline.checkin
    };

    sweetAlert('Alert', 'Are you sure you want to proceed?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.isSavingBreak = true;
          this.driverService
            .saveDriverBreak(payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              this.isSavingBreak = false;
              if (data) {
                this.showAddBreakModal = false;
                this.newBreak = { start: null, stop: null };
                this.timeline = data;
                this.buildTimelineEvents();
                this.getDriverTimelines();
              }
            }, () => {
              this.isSavingBreak = false;
            });
        }
      });
  }

  openAddSession() {
    this.newSession = {
      checkin: null,
      checkout: null
    };
    this.isSessionFormSubmitted = false;
    this.showAddSessionModal = true;
  }

  closeAddSession() {
    if (typeof Swal !== 'undefined' && Swal.isVisible && Swal.isVisible()) return;
    setTimeout(() => {
      this.showAddSessionModal = false;
      this.newSession = { checkin: null, checkout: null };
    }, 0);
  }

  checkOverlap(checkin, checkout, excludeSessionId?): boolean {
    if (!this.timeline || !this.timeline.sessions) return false;

    const newStart = moment(checkin).tz(this.timeZone);
    const newEnd = moment(checkout).tz(this.timeZone);

    return this.timeline.sessions.some(s => {
      if (excludeSessionId && s._id === excludeSessionId) {
        return false;
      }
      const existStart = moment(s.checkin).tz(this.timeZone);
      const existEnd = s.checkout ? moment(s.checkout).tz(this.timeZone) : null;

      if (existEnd) {
        return newStart.isBefore(existEnd) && existStart.isBefore(newEnd);
      } else {
        return existStart.isBefore(newEnd);
      }
    });
  }

  saveNewSession() {
    this.isSessionFormSubmitted = true;
    if (!this.newSession.checkin || !this.newSession.checkout) {
      return;
    }

    let checkinVal = moment(this.newSession.checkin).tz(this.timeZone);
    let checkoutVal = moment(this.newSession.checkout).tz(this.timeZone);

    if (this.timeline && this.timeline.checkin) {
      let baseDate = moment(this.timeline.checkin).tz(this.timeZone);
      checkinVal = baseDate.clone().hours(checkinVal.hours()).minutes(checkinVal.minutes()).seconds(0).milliseconds(0);
      checkoutVal = baseDate.clone().hours(checkoutVal.hours()).minutes(checkoutVal.minutes()).seconds(0).milliseconds(0);
    }

    if (moment.duration(checkoutVal.diff(checkinVal)).asSeconds() <= 0) {
      return sweetAlert('Alert', 'Time Out cannot be before or equal to Time In', 'warning', 'Ok');
    }

    const now = moment().tz(this.timeZone);
    if (checkinVal.isAfter(now)) {
      return sweetAlert('Alert', 'Time In cannot be after the current time', 'warning', 'Ok');
    }
    if (checkoutVal.isAfter(now)) {
      return sweetAlert('Alert', 'Time Out cannot be after the current time', 'warning', 'Ok');
    }

    if (this.checkOverlap(checkinVal, checkoutVal)) {
      return sweetAlert('Alert', 'This session overlaps with an existing session.', 'warning', 'Ok');
    }

    if (!this.timeline) return;
    if (!this.timeline.sessions) {
      this.timeline.sessions = [];
    }

    this.timeline.sessions.push({
      checkin: checkinVal.toISOString(),
      checkout: checkoutVal.toISOString()
    });

    // Sort sessions chronologically
    this.timeline.sessions.sort((a, b) => {
      return new Date(a.checkin).getTime() - new Date(b.checkin).getTime();
    });

    this.buildTimelineEvents();
    const times = this.calculateWorkAndBreakTime();
    if (times.workTimeInMillis) {
      this.timeline.workTimeInMillis = (times.workTimeInMillis - times.breakTimeInMillis) || 0;
    }
    this.timeline.breakTimeInMillis = times.breakTimeInMillis || 0;

    // Update checkin/checkout from remaining sessions
    if (this.timeline.sessions.length) {
      this.timeline.checkin = this.timeline.sessions[0].checkin;
      const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
      this.timeline.checkout = lastSession.checkout || null;
    }

    this.isSavingSession = true;
    this.driverService
      .saveDriverTimeline(this.timeline)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.isSavingSession = false;
        if (data) {
          this.timeline = data;
          this.buildTimelineEvents();
          this.getDriverTimelines();
          this.closeAddSession();
        }
      }, () => {
        this.isSavingSession = false;
      });
  }

  closeView() {
    if (this.isAnyOverlayOpen()) return;
    this.breakDetail = false;
    this.editShift = false;
    this.showEditSessionModal = false;
    this.showAddBreakModal = false;
    this.showAddSessionModal = false;
  }

  buildTimelineEvents() {
    if (!this.timeline) {
      this.timelineEvents = [];
      this.isDriverTimedIn = false;
      return;
    }

    // Determine if driver is currently timed in (last session has checkin but no checkout)
    if (this.timeline.sessions && this.timeline.sessions.length) {
      const lastSession = this.timeline.sessions[this.timeline.sessions.length - 1];
      this.isDriverTimedIn = lastSession && lastSession.checkin && !lastSession.checkout;
    } else {
      this.isDriverTimedIn = false;
    }

    const events = [];

    // Add session checkin/checkout entries
    if (this.timeline.sessions && this.timeline.sessions.length) {
      this.timeline.sessions.forEach(session => {
        if (session.checkin) {
          events.push({
            type: 'checkin',
            sortTime: session.checkin,
            data: session
          });
        }
        if (session.checkout) {
          events.push({
            type: 'checkout',
            sortTime: session.checkout,
            data: session
          });
        }
      });
    }

    // Add break entries
    if (this.timeline.breaks && this.timeline.breaks.length) {
      this.timeline.breaks.forEach(b => {
        events.push({
          type: 'break',
          sortTime: b.start || b.updatedAt,
          data: b
        });
      });
    }

    // Sort chronologically
    events.sort((a, b) => {
      return new Date(a.sortTime).getTime() - new Date(b.sortTime).getTime();
    });

    this.timelineEvents = events;
  }

  showDiff(timeline) {
    if (!timeline || !timeline.checkout || !timeline.lastTripTime) {
      return '';
    }

    const diff = Math.abs(moment(timeline.checkout).diff(moment(timeline.lastTripTime)));
    return this.viewHourFormat(moment.duration(diff).asMilliseconds());
  }

  calculateWorkAndBreakTime() {
    let workTimeInMillis = 0;
    let breakTimeInMillis = 0;

    if (this.timelineEvents && this.timelineEvents.length > 0) {
      let stopSumming = false;
      for (const event of this.timelineEvents) {
        if (stopSumming) {
          break;
        }

        if (event.type === 'checkin' && !event.data.checkout) {
          stopSumming = true;
        } else if (event.type === 'checkout') {
          const start = moment(event.data.checkin).tz(this.timeZone);
          const stop = moment(event.data.checkout).tz(this.timeZone);
          workTimeInMillis += moment.duration(stop.diff(start)).asMilliseconds();
        } else if (event.type === 'break') {
          if (event.data.duration) {
            breakTimeInMillis += event.data.duration;
          }
        }
      }
    }

    return { workTimeInMillis, breakTimeInMillis };
  }

  ngOnDestroy(): void {
  }

}
